


(function () {
  function searchToggle() {
    const modal = document.getElementById('search-modal');
    const body = document.body;
    const input = modal?.querySelector('.search__input');
    const trigger = document.querySelector('.search-modal-trigger');

    if (!modal) return;

    modal.classList.toggle('active');
    body.classList.toggle('overflow-hidden');

    if (modal.classList.contains('active')) {
      setTimeout(() => input?.focus(), 50);
    } else {
      trigger?.focus();
    }
  }

  function bindEvents() {
    document.querySelectorAll(
      '.search-modal-trigger, .search-modal__overlay, .search__close'
    ).forEach(el => {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        searchToggle();
      });
    });
  }

  document.addEventListener('keyup', function (e) {
    const modal = document.getElementById('search-modal');
    if (modal?.classList.contains('active') && e.key === 'Escape') {
      searchToggle();
    }
  });

  document.addEventListener('DOMContentLoaded', bindEvents);
  document.addEventListener('shopify:section:load', bindEvents);
})();

